var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        {
          staticClass: "ivu-mt",
          attrs: {
            shadow: "never",
            bordered: false,
            "body-style": { padding: 0 },
          },
        },
        [
          _c(
            "div",
            { staticClass: "padding-add" },
            [
              _c(
                "el-form",
                {
                  attrs: { inline: "", size: "small", "label-width": "78px" },
                  nativeOn: {
                    submit: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "线索搜索：" } },
                    [
                      _c("el-input", {
                        staticClass: "form_content_width",
                        attrs: {
                          clearable: "",
                          placeholder: "姓名 / 手机号 / 线索编号",
                        },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.handleSearch($event)
                          },
                        },
                        model: {
                          value: _vm.searchForm.keywords,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.searchForm,
                              "keywords",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "searchForm.keywords",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "线索状态：" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "form_content_width",
                          attrs: { clearable: "", placeholder: "全部状态" },
                          on: { change: _vm.handleSearch },
                          model: {
                            value: _vm.searchForm.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "status", $$v)
                            },
                            expression: "searchForm.status",
                          },
                        },
                        _vm._l(_vm.statusOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "线索来源：" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "form_content_width",
                          attrs: { clearable: "", placeholder: "全部来源" },
                          on: { change: _vm.handleSearch },
                          model: {
                            value: _vm.searchForm.sourceType,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "sourceType", $$v)
                            },
                            expression: "searchForm.sourceType",
                          },
                        },
                        _vm._l(_vm.sourceTypeOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "电商同步：" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "form_content_width",
                          attrs: { clearable: "", placeholder: "全部" },
                          on: { change: _vm.handleSearch },
                          model: {
                            value: _vm.searchForm.platformSyncStatus,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.searchForm,
                                "platformSyncStatus",
                                $$v
                              )
                            },
                            expression: "searchForm.platformSyncStatus",
                          },
                        },
                        _vm._l(_vm.platformSyncOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "留资时间：" } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "daterange",
                          "value-format": "yyyy-MM-dd",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                        },
                        on: { change: _vm.handleDateChange },
                        model: {
                          value: _vm.dateRange,
                          callback: function ($$v) {
                            _vm.dateRange = $$v
                          },
                          expression: "dateRange",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.handleSearch },
                        },
                        [_vm._v("查询")]
                      ),
                      _c("el-button", { on: { click: _vm.handleReset } }, [
                        _vm._v("重置"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-card",
        {
          staticClass: "mt14",
          attrs: {
            shadow: "never",
            bordered: false,
            "body-style": { padding: "20px" },
          },
        },
        [
          _c(
            "div",
            { staticClass: "list-title" },
            [
              _c("span", [_vm._v("意向业主线索")]),
              _c("span", { staticClass: "list-tip" }, [
                _vm._v("支持五源异构筛选；跟进超时线索可批量回收公海"),
              ]),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "mini",
                    type: "warning",
                    plain: "",
                    loading: _vm.recycleLoading,
                  },
                  on: { click: _vm.recycleStale },
                },
                [_vm._v("公海超时回收")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "mt20",
              attrs: {
                data: _vm.tableData.data,
                size: "mini",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "leadNo",
                  label: "线索编号",
                  "min-width": "190",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "name", label: "联系人", "min-width": "90" },
              }),
              _c("el-table-column", {
                attrs: { prop: "mobile", label: "手机号", "min-width": "120" },
              }),
              _c("el-table-column", {
                attrs: { prop: "city", label: "城市", "min-width": "90" },
              }),
              _c("el-table-column", {
                attrs: { label: "房屋类型", "min-width": "90" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          _vm._s(_vm.houseTypeText[row.houseType] || "--")
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "layout", label: "户型", "min-width": "90" },
              }),
              _c("el-table-column", {
                attrs: { label: "面积", "min-width": "90" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_vm._v(_vm._s(row.buildingArea) + " m²")]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "来源", "min-width": "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          _vm._s(
                            _vm.sourceTypeText[row.sourceType] ||
                              row.sourceType ||
                              "--"
                          )
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "电商同步", "min-width": "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        row.platformSyncStatus
                          ? _c(
                              "el-tag",
                              {
                                attrs: {
                                  size: "mini",
                                  type:
                                    _vm.platformSyncTag[
                                      row.platformSyncStatus
                                    ] || "info",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.platformSyncText[
                                        row.platformSyncStatus
                                      ] || row.platformSyncStatus
                                    ) +
                                    " "
                                ),
                              ]
                            )
                          : _c("span", [_vm._v("--")]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "留资页", "min-width": "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          _vm._s(
                            _vm.sourcePageText[row.sourcePage] ||
                              row.sourcePage ||
                              "--"
                          )
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "状态", "min-width": "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              size: "mini",
                              type: _vm.statusTagType[row.status] || "info",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.statusText[row.status] || row.status
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "跟进人", "min-width": "110" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_vm._v(_vm._s(row.ownerStaffName || "--"))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "下次动作时间", "min-width": "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_vm._v(_vm._s(row.nextFollowTime || "--"))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "方案报价", "min-width": "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        row.quoteNo
                          ? _c("div", { staticClass: "quote-summary" }, [
                              _c("span", [_vm._v(_vm._s(row.quoteNo))]),
                              _c("strong", [
                                _vm._v(
                                  "¥" +
                                    _vm._s(
                                      _vm.formatMoney(row.quoteTotalAmount)
                                    )
                                ),
                              ]),
                            ])
                          : _c("span", [_vm._v("--")]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "报价状态", "min-width": "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        row.quoteStatus
                          ? _c(
                              "el-tag",
                              {
                                attrs: {
                                  size: "mini",
                                  type:
                                    row.quoteStatus === "submitted"
                                      ? "success"
                                      : "warning",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.quoteStatusText[row.quoteStatus] ||
                                        row.quoteStatus
                                    ) +
                                    " "
                                ),
                              ]
                            )
                          : _c("span", [_vm._v("--")]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "报价提交时间", "min-width": "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_vm._v(_vm._s(row.quoteSubmittedTime || "--"))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "设计合同", "min-width": "190" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        row.designContractNo
                          ? _c("div", { staticClass: "quote-summary" }, [
                              _c("span", [
                                _vm._v(_vm._s(row.designContractNo)),
                              ]),
                              _c("strong", [
                                _vm._v(
                                  "¥" +
                                    _vm._s(
                                      _vm.formatMoney(row.designContractAmount)
                                    )
                                ),
                              ]),
                            ])
                          : _c("span", [_vm._v("--")]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "合同状态", "min-width": "110" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        row.designContractStatus
                          ? _c(
                              "el-tag",
                              {
                                attrs: {
                                  size: "mini",
                                  type:
                                    _vm.contractTagType[
                                      row.designContractStatus
                                    ] || "info",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.contractStatusText[
                                        row.designContractStatus
                                      ] || row.designContractStatus
                                    ) +
                                    " "
                                ),
                              ]
                            )
                          : _c("span", [_vm._v("--")]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "合同签署时间", "min-width": "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(_vm._s(row.designContractSignedTime || "--")),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "装修合同", "min-width": "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        row.renovationContractNo
                          ? _c("div", { staticClass: "quote-summary" }, [
                              _c("span", [
                                _vm._v(_vm._s(row.renovationContractNo)),
                              ]),
                              _c("strong", [
                                _vm._v(
                                  "¥" +
                                    _vm._s(
                                      _vm.formatMoney(
                                        row.renovationContractAmount
                                      )
                                    )
                                ),
                              ]),
                            ])
                          : _c("span", [_vm._v("--")]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "装修合同状态", "min-width": "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        row.renovationContractStatus
                          ? _c(
                              "el-tag",
                              {
                                attrs: {
                                  size: "mini",
                                  type:
                                    _vm.contractTagType[
                                      row.renovationContractStatus
                                    ] || "info",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.contractStatusText[
                                        row.renovationContractStatus
                                      ] || row.renovationContractStatus
                                    ) +
                                    " "
                                ),
                              ]
                            )
                          : _c("span", [_vm._v("--")]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "收款进度", "min-width": "190" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        row.renovationContractStatus === "effective"
                          ? _c("div", { staticClass: "receipt-summary" }, [
                              _c("span", [
                                _vm._v(
                                  "已收 ¥" +
                                    _vm._s(
                                      _vm.formatMoney(row.renovationPaidAmount)
                                    )
                                ),
                              ]),
                              _c("span", [
                                _vm._v(
                                  "待收 ¥" +
                                    _vm._s(
                                      _vm.formatMoney(
                                        row.renovationOutstandingAmount
                                      )
                                    )
                                ),
                              ]),
                            ])
                          : _c("span", [_vm._v("--")]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "装修签署时间", "min-width": "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          _vm._s(row.renovationContractSignedTime || "--")
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "留资时间",
                  "min-width": "160",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "操作", fixed: "right", "min-width": "90" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        row.status === "unassigned"
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.openAssign(row)
                                  },
                                },
                              },
                              [_vm._v(" 分配 ")]
                            )
                          : _c("span", { staticClass: "disabled-operation" }, [
                              _vm._v("--"),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "page-sizes": _vm.$constants.page.limit,
                  "page-size": _vm.searchForm.limit,
                  "current-page": _vm.searchForm.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "分配跟进人",
            visible: _vm.assignVisible,
            width: "460px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.assignVisible = $event
            },
            closed: _vm.resetAssign,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "assignForm",
              attrs: {
                model: _vm.assignForm,
                rules: _vm.assignRules,
                "label-width": "88px",
                size: "small",
              },
            },
            [
              _c("el-form-item", { attrs: { label: "意向业主" } }, [
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.currentLead.name || "--") +
                      "（" +
                      _vm._s(_vm.currentLead.mobile || "--") +
                      "）"
                  ),
                ]),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "跟进职员", prop: "staffId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { filterable: "", placeholder: "请选择跟进职员" },
                      model: {
                        value: _vm.assignForm.staffId,
                        callback: function ($$v) {
                          _vm.$set(_vm.assignForm, "staffId", $$v)
                        },
                        expression: "assignForm.staffId",
                      },
                    },
                    _vm._l(_vm.staffOptions, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: {
                          label:
                            item.name +
                            "（" +
                            (_vm.jobTypeText[item.jobType] || item.jobType) +
                            "）",
                          value: item.id,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "分配备注", prop: "remark" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      maxlength: "200",
                      "show-word-limit": "",
                      placeholder: "选填",
                    },
                    model: {
                      value: _vm.assignForm.remark,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.assignForm,
                          "remark",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "assignForm.remark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.assignVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    loading: _vm.assignLoading,
                  },
                  on: { click: _vm.submitAssign },
                },
                [_vm._v("确认分配")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }